/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const loupe = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M11.5 11.5 15 15m-3.182-8.59A5.41 5.41 0 1 1 1 6.41a5.41 5.41 0 0 1 10.818 0Z"
    />
  </svg>
)
export default loupe
